import { render } from "./AllRoles.vue?vue&type=template&id=eab3fe6c"
import script from "./AllRoles.vue?vue&type=script&lang=js"
export * from "./AllRoles.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__